<template>
  <div class="mx-4 pb-2">
    <v-row>
      <v-col cols="12">
        <h2 class="font-weight-bold">{{ $t('profile.views.IdentityChecking.title') }}</h2>
      </v-col>
    </v-row>

    <v-row v-if="idCheckStatePending">
      <v-col cols="12" class="text-center">
        <v-progress-circular size="24" indeterminate color="primary"/>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <template v-if="canCurrentUserSign">
          <p>
            <font-awesome-icon class="text-success" :icon="['fas', 'check-circle']"></font-awesome-icon>
            {{ $t('profile.views.IdentityChecking.verified', { untilDate: validUntilDate }) }}
          </p>
        </template>
        <template v-else>
          <p>{{ $t('profile.views.IdentityChecking.notVerified') }}</p>
          <div class="text-center">
            <AppButton
                class="mt-4"
                color="primary"
                @click="SET_SHOW_IDENTITY_CHECK_MODAL(true)"
            >
              {{ $t('profile.views.IdentityChecking.verifyBtn') }}
            </AppButton>
          </div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import AppButton from '../../common/buttons/AppButton.vue'
import { ISOToDDMMYYYY } from '../../common/utils/dates'
import { GET_ID_CHECK_STATE } from '../../store/modules/user/action_types'
import { SET_SHOW_IDENTITY_CHECK_MODAL } from '../../store/modules/user/mutation_types'
const { mapMutations, mapActions, mapState } = createNamespacedHelpers('user')

export default {
  name: 'IdentityChecking',
  components: { AppButton },
  computed: {
    ...mapState(['idCheckState', 'idCheckStatePending']),
    canCurrentUserSign () {
      return this.idCheckState && this.idCheckState.hasValidIdCheck
    },
    validUntilDate () {
      return this.canCurrentUserSign && ISOToDDMMYYYY(this.idCheckState.idCheckValidUntil)
    },
  },
  created () {
    this.GET_ID_CHECK_STATE()
  },
  methods: {
    ...mapActions([GET_ID_CHECK_STATE]),
    ...mapMutations([SET_SHOW_IDENTITY_CHECK_MODAL]),
  },
}
</script>
